export default {
  groups: {
    dashboards: 'Dashboards',
    home: 'Home',
    online_shop: 'Online Shop',
    marketing: 'Marketing',
    reservations: 'Reservierungen',
    phone_answering: 'Telefonbeantwortung',
    website: 'Website',
    orders_portal: 'Start des Bestell-Portal',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Mobile App',
    pricing: 'Preisübersicht',
    team: 'Team',
    data_deletion_requests: 'Anträge auf Datenlöschung',
    partner: 'Partner',
  },
  get_started: {
    title: "Los geht's",
  },
  onboarding: {
    title: 'Launch',
  },
  new_restaurant: {
    title: 'Neues Restaurant',
  },
  gift_cards: {
    title: 'Geschenkkarten',
  },
  top_items: {
    title: 'Top-Artikel',
  },
  dashboards: {
    title: 'Dashboards',
    children: {
      general: 'Allgemein',
      restaurant_details: 'Restaurantdetails',
      external_delivery: 'Externe Lieferung',
      overview: 'Übersicht',
      orders: 'Bestellungen nach Quelle',
      google: 'Google',
      customers: 'Kunden',
    },
  },
  customer_base: {
    title: 'Kundenstamm',
  },
  new_company: {
    title: 'Neues Restaurant',
  },
  agent_ops_queue: {
    title: 'KI-Vorschläge',
  },
  external_delivery_support: {
    title: 'Externe Lieferung Unterstützung',
  },
  payment_gateways: {
    title: 'Zahlungsgateways',
  },
  developers: {
    title: 'Entwickler',
  },
  feature_flags: {
    title: 'Feature-Flags',
  },
  test_restaurants: {
    title: 'Testrestaurants',
  },
  partners: {
    title: 'Partner',
  },
  partner: {
    children: {
      account: 'Konto',
      branding: 'Branding',
      payment_gateway: 'Zahlungs-Gateway',
      billing: 'Abrechnung',
      tax_currency: 'Steuern & Währung',
      service_fee_calculator: 'Servicegebühr-Rechner',
      processing_fees: 'Verarbeitungsgebühren',
    },
  },
  going_live: {
    title: 'Live-Schaltung',
    children: {
      setup_package_fulfillments: 'Logsta-Erfüllungen',
      polygraphy: 'Druck Artikel',
    },
  },
  setup_package_fulfillments: {
    title: 'Erfüllung der Setup-Pakete',
  },
  franchises: {
    title: 'Marken',
  },
  website: {
    title: 'Website',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reservierungen',
    children: {
      overview: 'Übersicht',
      booking_availability: 'Buchungsverfügbarkeit',
      settings: 'Einstellungen',
      general: 'Allgemein',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Abonnements',
    children: {
      subscriptions: 'Abonnements',
      products: 'Produkte',
    },
  },
  sales: {
    title: 'Bestellungen',
    children: {
      orders: 'Bestellungen',
      receipts: 'Rechnung für Bestellung',
      external_deliveries: 'Externe Lieferungen',
    },
  },
  billing: {
    title: 'Berichte',
    children: {
      monthly_statements: 'Monatliche Abrechnungsdokumente',
      payouts: 'Auszahlung',
      invoices: 'Rechnungen',
      subscription: 'Abonnement',
      sales_summary: 'Umsatzübersicht',
      internal_invoice_items: 'Interne Rechnungsposten',
      income_reports: 'Einkommensberichte',
      tax_reports: 'Steuerberichte',
    },
  },
  master_menu: {
    title: 'Marken-Sync',
  },
  menu: {
    title: 'Menü',
    children: {
      master_overview: 'Marken',
      manage_menus: 'Speisekarte',
      modifiers: 'Modifizierer',
      smart_pricing: 'Intelligente Preise',
      upsell_items: 'Upsell Artikel',
      sold_out_items: 'Ausverkaufte Artikel',
      import: 'Importieren',
      edit_history: 'Änderungsverlauf',
    },
  },
  my_store: {
    title: 'Meine Info',
    children: {
      settings: 'Profil',
      gallery: 'Gallerie',
      business_information: 'Geschäftliche Information',
      documents: 'Meine Dokumente',
      personal_information: 'Persönliche Information',
      bank_info: 'Bank Details',
      tax_info: 'Steuerinfo',
      shipping_info: 'Lieferadresse',
      google_profile: 'Google Profil',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Impressum',
      post_launch: 'Nach dem Launch',
      tax_currency: 'Steuern & Währung',
    },
  },
  opening_hours: {
    title: 'Öffnungszeiten & Standort',
    children: {
      opening_hours: 'Öffnungszeiten',
      location: 'Standort',
    },
  },
  order_settings: {
    title: 'Bestell Einstellungen',
    children: {
      takeout: 'Bestellmethoden',
      order_layout: 'Bestell Layout',
      payment_methods: 'Zahlungsarten',
      connect_paypal: 'PayPal verbinden',
      tips: 'Trinkgeld',
      service_fee: 'Gebühren',
      processing_fees: 'Verarbeitungsgebühren',
      receipt: 'Druck Bon',
      staff_credentials: 'Mitarbeiter Zugang',
      integrations: 'Integrationen',
      terminal: 'Terminal',
      invoices: 'Rechnungen',
    },
  },
  mobile_app: {
    title: 'Mobile App',
    children: {
      overview: 'Übersicht',
      updates: 'Updates',
      intro_screen: 'Intro-Bildschirm',
    },
  },
  marketing: {
    children: {
      overview: 'Übersicht',
      followers: 'Follower',
      email_messages: 'E-Mail-Nachrichten',
      push_notifications: 'Push-Nachrichten',
      promo_codes: 'Promo codes',
      offers: 'Angebote',
      google_business: 'Google Business',
      google_review_program: 'Google-Bewertungsprogramm',
      loyalty_program: 'Loyalitätsprogramm',
      polygraphy: 'Druck Artikel',
      tracking_links: 'Tracking-Links',
      google_ads: 'Google Werbung',
      website_analytics: 'Website Analytics',
      featured_posts: 'Beiträge Mobile App',
    },
  },
  loyalty_tablet: {
    title: 'Loyalty Tablet',
    children: {
      dashboard: 'Dashboard',
      settings: 'Einstellungen',
      credentials: 'Credentials',
    },
  },
  contract: {
    title: 'Vertrag',
    children: {
      agreement: 'Vertrag',
      template: 'Template',
    },
  },
  team: {
    children: {
      managers: 'Managers',
      reports: 'Berichte',
    },
  },
};
